


export const boxShadow = '1px 1px 6px 1px rgba(0, 0, 0, 0.07)';